<template>
    <kgr-multi-select
        display="name"
        :label="label"
        :options="filteredSports"
        :value="selection"
        :loading="loading"
        :max-selects="1"
        searchable
        @post-input="emitSelectedValue($event)"
    />
</template>

<script>
import MultiSelect from './MultiSelect.vue';
import SportsRepository from '../../../../js/repository/SportsRepository';

export default {
    components: {
        'kgr-multi-select': MultiSelect,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        value: {
            type: Object,
            required: false,
            default: () => {
                return null
            },
        },
        excludedIds: {
            type: Array,
            required: false,
            default: () => {
                return []
            },
        },
        hideLabel: {
            type: Boolean,
            required: false,
            default: false,
        }
    },
    data() {
        return {
            selection: [],
            loading: true,
            sports: [],
        }
    },
    computed: {
        label() {
            return this.hideLabel ? null : this.$t('sports');
        },
        filteredSports() {
            return this.sports.filter(sport => this.excludedIds.indexOf(sport.id) === -1);
        }
    },
    created() {
        SportsRepository
            .findAll(this.clubId)
            .then(sports => {
                this.sports = [];
                sports.forEach(sport => {
                    if (!sport.isArchived) {
                        this.sports.push(
                            {
                                id: sport.id,
                                name: sport.name,
                            }
                        )
                    }
                });
                if (this.value) {
                    this.sports.forEach(sport => {
                        if (sport.id === this.value.id) {
                            this.selection = [sport];
                        }
                    })
                }
                this.loading = false;
            })
            .catch(() => this.$notify.error('error.loadingData'));
    },
    methods: {
        emitSelectedValue(value) {
            if(value.length === 0) {
                this.selection = [];
                this.$emit('input', null);
                this.$nextTick(() => {
                    this.$emit('post-input', null);
                });
            }
            if(value.length > 0) {
                this.selection = value;
                this.$emit('input', value[0]);
                this.$nextTick(() => {
                    this.$emit('post-input', value[0]);
                });
            }
        }
    },
}
</script>
